<template>
  <div class="page-container">
    <div class="page-title-container">
      <h1 class="page-title">Tipos de planilla</h1>
    </div>
    <div class="table-container">
      <div class="table-header">
        <div class="d-flex flex-column flex-md-row justify-content-between align-items-start position-relative">
          <div class="w-full w-md-auto md-flex-1">
            <div class="d-flex justify-content-between align-items-center justify-content-lg-start">
              <button type="button" class="filter d-flex align-items-center justify-content-between border-0"
                @click="showFilters = !showFilters">
                <i class="ri-filter-3-line text-dark font-weight-bold"></i>
                <div>Filtrar</div>
              </button>
              <div class="d-md-none">
                <button type="button" class="button-tooltip text-dark font-weight-bold m-0"
                  v-b-tooltip.hover title="Recargar" @click="loadData()">
                  <i class="ri-loop-right-line"></i>
                </button>
              </div>
            </div>
          </div>
          <section class="w-full w-md-auto md-flex-1 d-flex justify-content-end align-items-center mt-2 mt-md-0">
            <div class="d-none d-md-flex">
              <button type="button" class="button-tooltip text-dark font-weight-bold"
                v-b-tooltip.hover title="Recargar" @click="loadData()">
                <i class="ri-loop-right-line"></i>
              </button>
            </div>
            <div class="w-full w-md-auto d-flex flex-column flex-md-row">
              <div class="text-right mt-2 mt-md-0">
                <b-button :to="{ name: 'payroll-type-create' }" variant="none" class="button button-primary ml-md-2">Agregar</b-button>
              </div>
            </div>
          </section>
          <filter-menu :show="showFilters" @hide="showFilters = false"
            :options="filterOptions" :selectedOptionFilter="filters" @setFilters="setFilters" />
        </div>
      </div>

      <!-- Desktop -->
      <table class="custom-table w-100 d-none d-xl-table">
        <thead>
          <tr>
            <th>CODIGO</th>
            <th>NOMBRE</th>
            <th>FRECUENCIA</th>
            <th>CATEGORIA</th>
            <th class="text-center">BS</th>
            <th class="text-center">AF</th>
            <th class="text-center">PENSION</th>
            <th class="text-center">ESSALUD</th>
            <th class="text-center">IR</th>
            <th>ESTADO</th>
            <th class="pr-md-3">OPCIONES</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="list.length === 0">
            <td colspan="11" class="text-center text-muted py-4">No se encontraron resultados.</td>
          </tr>
          <tr v-for="o in list" :key="o.id">
            <td class="pl-3">{{ o.code }}</td>
            <td class="pl-3">{{ o.name }}</td>
            <td class="cell-center">
              <span :class="`badge ${getFrequencyBadge(o.frequency)}`">{{ getFrequencyLabel(o.frequency) }}</span>
            </td>
            <td class="cell-center">
              <span :class="`badge ${o.taxCategory === 'FIFTH' ? 'badge-info' : 'badge-secondary'}`">
                {{ o.taxCategory === 'FIFTH' ? '5ta' : '4ta' }}
              </span>
            </td>
            <td class="text-center"><i :class="o.affectsSocialBenefits ? 'ri-check-line text-success' : 'ri-close-line text-muted'"></i></td>
            <td class="text-center"><i :class="o.includesFamilyAllowance ? 'ri-check-line text-success' : 'ri-close-line text-muted'"></i></td>
            <td class="text-center"><i :class="o.includesPension ? 'ri-check-line text-success' : 'ri-close-line text-muted'"></i></td>
            <td class="text-center"><i :class="o.includesEssalud ? 'ri-check-line text-success' : 'ri-close-line text-muted'"></i></td>
            <td class="text-center"><i :class="o.includesIr ? 'ri-check-line text-success' : 'ri-close-line text-muted'"></i></td>
            <td class="cell-center pl-md-2">
              <span :class="`badge ${getStatus(o.status).color}`">{{ getStatus(o.status).label }}</span>
            </td>
            <td class="cell-center d_option pr-md-2 position-relative">
              <DropdownTable>
                <template slot="dropdown-content">
                  <DropdownItem text="Editar" :to="{ name: 'payroll-type-edit', params: { id: o.id } }" />
                  <DropdownItem :text="getStatus(o.status).action" @click="openChangeStatus(o)" />
                </template>
              </DropdownTable>
            </td>
          </tr>
        </tbody>
      </table>

      <!-- Mobile -->
      <div class="custom-table-mobile d-xl-none">
        <section class="custom-table-mobile-header">
          <div><span>Nombre</span></div>
          <div><span>Estado</span></div>
        </section>
        <div class="custom-table-mobile-body">
          <div class="custom-table-mobile-row" v-for="o in list" :key="o.id">
            <div class="custom-table-mobile-grid">
              <div><span>{{ o.name }}</span></div>
              <div><span :class="`badge ${getStatus(o.status).color}`">{{ getStatus(o.status).label }}</span></div>
              <div>
                <button type="button" class="border-0 bg-transparent" @click="o.showMobileData = !o.showMobileData">
                  <i :class="o.showMobileData ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'"></i>
                </button>
              </div>
            </div>
            <div v-if="o.showMobileData" class="pt-3">
              <ul class="list-unstyled p-0">
                <li><span class="font-weight-medium mr-2">Codigo:</span>{{ o.code }}</li>
                <li><span class="font-weight-medium mr-2">Frecuencia:</span>{{ getFrequencyLabel(o.frequency) }}</li>
                <li><span class="font-weight-medium mr-2">Categoria:</span>{{ o.taxCategory === 'FIFTH' ? '5ta categoria' : '4ta categoria' }}</li>
              </ul>
            </div>
            <div class="custom-table-mobile-options mt-3">
              <router-link :to="{ name: 'payroll-type-edit', params: { id: o.id } }" class="mx-3">Editar</router-link>
              <a href="" @click.prevent="openChangeStatus(o)">{{ getStatus(o.status).action }}</a>
            </div>
          </div>
        </div>
      </div>

      <div class="table-footer d-flex justify-content-end align-items-center">
        <p v-if="list.length > 0" class="m-0 px-3 text-muted small">{{ list.length }} registro(s)</p>
      </div>
    </div>

    <ConfirmationModal :show="confirmationModal.show" @hide="closeConfirmationModal"
      :data="confirmationModal" @confirm="confirmModal" />
  </div>
</template>

<script>
import { Constants, Util, Alert, FilterMenu, FilterMixin, DropdownTable, DropdownItem, ConfirmationModal, ConfirmationModalMixin } from 'wize-admin'
import { Constants as LocalConstants } from '@/core/utils'
import { PayrollTypeService } from '@/core/services'

export default {
  mixins: [FilterMixin, ConfirmationModalMixin],
  components: { FilterMenu, DropdownTable, DropdownItem, ConfirmationModal },
  data() {
    return {
      list: [],
      showFilters: false,
      filterOptions: [
        { label: 'Estado', key: 'status', type: Constants.TypeFilters.SINGLE,
          options: [LocalConstants.PayrollTypeStatus.ACTIVE, LocalConstants.PayrollTypeStatus.INACTIVE] },
      ],
    }
  },
  methods: {
    async loadData() {
      try {
        await this.$store.dispatch('app/loading', true)
        const resp = await PayrollTypeService.list()
        this.list = (resp.payload || []).map(i => ({ ...i, showMobileData: false }))
      } catch (e) {
        console.error(e)
        Alert.error(e.errors ? e.errors.message : 'Error al cargar tipos de planilla')
      } finally {
        await this.$store.dispatch('app/loading', false)
      }
    },
    getStatus(key) { return Util.searchValue(parseInt(key), LocalConstants.PayrollTypeStatus) },
    getFrequencyLabel(freq) {
      const map = { WEEKLY: 'Semanal', BIWEEKLY: 'Quincenal', MONTHLY: 'Mensual' }
      return map[freq] || freq
    },
    getFrequencyBadge(freq) {
      const map = { WEEKLY: 'badge-warning', BIWEEKLY: 'badge-info', MONTHLY: 'badge-green' }
      return map[freq] || 'badge-gray'
    },
    openChangeStatus(o) {
      this.selectedOption = o
      this.openConfirmationModal({ title: 'Cambiar estado', description: '¿Esta seguro que desea cambiar el estado?', acceptText: 'Aceptar', action: 'update' })
    },
    confirmModal() { this.closeConfirmationModal(); if (this.confirmationModal.action === 'update') this.changeStatus() },
    async changeStatus() {
      try {
        await this.$store.dispatch('app/loading', true)
        const status = this.selectedOption.status === LocalConstants.PayrollTypeStatus.ACTIVE.key
          ? LocalConstants.PayrollTypeStatus.INACTIVE.key : LocalConstants.PayrollTypeStatus.ACTIVE.key
        await PayrollTypeService.changeStatus(this.selectedOption.id, status)
        await this.loadData()
        Alert.success('Estado actualizado correctamente')
      } catch (ex) {
        console.error(ex); Alert.error(ex.errors ? ex.errors.message : 'Error al cambiar estado')
      } finally { await this.$store.dispatch('app/loading', false) }
    },
  },
  async created() { await this.loadData() },
}
</script>

<style lang="stylus">
@import '../../Areas/Styles/supplier-list'
</style>
